// frontend/src/services/firebase.js
import { initializeApp, getApp, getApps } from 'firebase/app';
import {
  getFirestore,
  connectFirestoreEmulator,
  serverTimestamp, // ⬅️ adiciona
  Timestamp, // ⬅️ (opcional) útil em vários pontos
} from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyAKfxBebk4X5PZvRrYuiLw9QTwsi_bv5fE',
  authDomain: 'elioncadastro.firebaseapp.com',
  projectId: 'elioncadastro',
  storageBucket: 'elioncadastro.firebasestorage.app',
  messagingSenderId: '94968603074',
  appId: '1:94968603074:web:bb083652cd45d638f83b65b',
  measurementId: 'G-H0N8619VBZ',
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// região das Cloud Functions (ajuste se usar outra)
const REGION = import.meta.env.VITE_FIREBASE_REGION || 'us-central1';
const functions = getFunctions(app, REGION);

// Emuladores (opcional)
const useEmulators = import.meta.env.VITE_USE_EMULATORS === '1';

if (useEmulators) {
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
  } catch {}
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
  } catch {}
  try {
    connectStorageEmulator(storage, 'localhost', 9199);
  } catch {}
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch {}
}

export {
  app,
  db,
  auth,
  storage,
  functions,
  serverTimestamp, // ⬅️ agora disponível para import nos seus componentes
  Timestamp, // ⬅️ opcional
};
